module.exports = __webpack_public_path__ + "static/media/dental.3f684227.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/dental.svg
// module id = 645
// module chunks = 0